// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import style from './MultiImage.scss';

import type { OrderItem } from '../../entities';

type Props = {
  items: OrderItem[];
};

export default class MultiImage extends Component<Props> {
  render() {
    const { items } = this.props;
    const itemsContent = items && [0, 1, 2, 3].map((n: number) => {
      if (items[n]) {
        return (
          <Fragment key={n}>
            <img className={classNames(style[`image-${n}`])}
                 key={`item-${n}`}
                 src={(items[n].image || items[n].orderItem.image)}
                 alt={items[n].name}/>
            {(n === 3 && items.length > 4) && <section className={style.hasMore}>{`+${items.length - 4}`}</section>}
          </Fragment>);
      } else if (items.length > 1) {
        return <section key={n} className={classNames(
          { [style.default1]: n === 2 },
          { [style.default2]: n === 3 })}/>
      }
    });

    return (
      <section className={classNames(style.multiImageWrap,
        { [style.sizeAlone]: items.length === 1 },
        { [style.sizeMulti]: items.length > 1 })}>
        {itemsContent}
      </section>
    );
  }
}

MultiImage.propTypes = {
  items: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./src/elements/MultiImage/MultiImage.jsx